import React from 'react';
import api from './apiConnector'

import { StatusDisplay } from './status.js';
import Devis from './devis.js'
import SearchBar from './searchBar.js'
import DataDevis from './dataDevis.js';

Array.prototype.emptyOrSome = function(f) {
    return ( this.length == 0 )|| this.some(f)
}

const CreateNewDevis = (p) => {
    
    return <a className="create_new_devis"  target="_blank" href={api.frontUrl(p.type)}>Créer un nouveau devis</a>
}

class ListDevis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            devis:[],
            users:[],
            isFull:false,
            nextOffset:0,
            searchName:false,
            count:-1,
            loading:false,
            loadingCount:false,
            sponsors:[]
        }
        this.bottomRef = React.createRef()
        let me  = this
        this.observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach((entry) => {
                if ( entry.isIntersecting ) {
                    me.onBottom()
            }})
        });
        this.expandingFromOffset = 0
        this.requestId = 0
    }    
    
    componentDidUpdate(prevProps) {
        if (
            ( prevProps.type != this.props.type )||
            ( prevProps.quotations != this.props.quotations )||
            ( prevProps.filterName != this.props.filterName )||
            ( prevProps.filterTelephone != this.props.filterTelephone )||
            ( prevProps.searchSelf != this.props.searchSelf )||
            ( prevProps.searchUnvalidated != this.props.searchUnvalidated )||
            ( prevProps.searchStatus != this.props.searchStatus )||
            ( prevProps.searchStatusProcess != this.props.searchStatusProcess )||
            ( prevProps.startDate != this.props.startDate )||
            ( prevProps.endDate != this.props.endDate )||
            ( prevProps.dateType != this.props.dateType )||
            ( prevProps.startDateModif != this.props.startDateModif )||
            ( prevProps.endDateModif != this.props.endDateModif )||
            ( prevProps.searchUser != this.props.searchUser )||
            ( prevProps.searchApporteur != this.props.searchApporteur )||
            ( prevProps.searchNoSolly != this.props.searchNoSolly )||
            ( prevProps.searchAffiliateOnly != this.props.searchAffiliateOnly )||
            ( prevProps.searchAssureur != this.props.searchAssureur )||
            ( prevProps.searchAssureurOrigin != this.props.searchAssureurOrigin )||
            ( prevProps.increment != this.props.increment )
            
        ) {
            // Filters and criteria changed : reset the list of devis
            this.initialLoad()
        }
    }


    componentDidMount() {
        let me = this
        api.registerDevisView(this)
        this.initialLoad()

        if ( this.props.operator ) {
            api.post(
                {action:'list_users'},
                (res)=>{
                    me.setState({users:res.users})
                }
            )
        }

        this.observer.observe( this.bottomRef.current );
    }

    getSponsor(id) {
        id = id.substring(0,24)
        return this.state.sponsors.find(
            sponsor=>sponsor._id.$oid == id
        )
    }

    initialLoad() {
        this.setState({
            isFull:false,
            loading:true,
            count:-1,
            nextOffset:0 // First offset that is not in state.listdevis yet
        })
        this.loadListFrom(0)
    }

    makeListPayload(currentOffset,count=false) {
        let payload = {
            action:'list_devis',
            type:this.props.type,
            offset:currentOffset,
            limit:25,
            count:count,
            quotations:this.props.quotations?'1':'',
            email:this.props.email,
            filterName:this.props.filterName,
            filterTelephone:this.props.filterTelephone,
            searchSelf:this.props.searchSelf,
            startDate : this.props.startDate ? Math.floor(this.props.startDate.getTime()/1000) : 0,
            endDate : this.props.endDate ? Math.floor(this.props.endDate.getTime()/1000)+3600*24 : 0,
            startDateModif : this.props.startDateModif ? Math.floor(this.props.startDateModif.getTime()/1000) : 0,
            endDateModif : this.props.endDateModif ? Math.floor(this.props.endDateModif.getTime()/1000)+3600*24 : 0,
            requestId : ++ this.requestId
        }
        if ( this.props.searchUnvalidated ) payload.validated = -2
        if ( this.props.searchUser ) payload.searchUser = this.props.searchUser
        if ( this.props.searchStatus ) payload.searchStatus = this.props.searchStatus.map(e=>e.value)
        if ( this.props.searchStatusProcess ) payload.searchStatusProcess = this.props.searchStatusProcess.map(e=>e.value)
        if ( this.props.searchApporteur ) payload.searchApporteur = this.props.searchApporteur.map(e=>e.value)
        if ( this.props.searchNoSolly ) payload.searchNoSolly = 1
        if ( this.props.searchAffiliateOnly ) payload.affiliateOnly = 1
        if ( this.props.searchAssureur ) payload.assureur = this.props.searchAssureur
        if ( this.props.searchAssureurOrigin ) {
            payload.assureur = this.props.searchAssureurOrigin
            payload.assureur_by_origin = 1
        }
        return payload
    }

    loadListFrom(currentOffset) {
        this.expandingFromOffset = currentOffset // expandingFromOffset : identifies the last call to loadListFrom
        api.post(
            this.makeListPayload(currentOffset),
            (res)=>{
                if (( this.state.nextOffset == currentOffset )&&( this.requestId == res.requestId )) {
                    const list = res.listdevis.filter(devis=>devis._id.$oid!=this.props.avoid)
                    this.setState({
                        devis : currentOffset ? this.state.devis.concat( list ) : list,
                        isFull : res.listdevis.length<25,
                        nextOffset : currentOffset + res.listdevis.length,
                        loading:false
                    })
                }
            }
        )
    }

    loadCount() {
        this.setState({loadingCount:true})
        api.post(
            this.makeListPayload(0,true),
            (res)=>{
                this.setState({count:res.count,loadingCount:false})
            }
        )
    }

    exportCsv() {
        let payload = this.makeListPayload(0)
        payload.format = 'csv'
        window.open(api.makeUrl(
             payload
        ))
    }

    componentWillUnmount() {
        api.unregisterDevisView(this)
    }

    backToTop() {
        window.scrollTo(0,0)
    }

    onFilter() {

    }

    onBottom() {
        if (( !this.state.isFull )&& this.state.nextOffset &&( this.expandingFromOffset < this.state.nextOffset )) {
            this.loadListFrom( this.state.nextOffset )
        }
    }

    receiveDevis(rdevis) {
        this.setState({devis:this.state.devis.map(
            devis=>{
                if ( devis._id.$oid == rdevis._id.$oid ) return rdevis
                return devis
            }
        )})
    }

    setCommercial( devisId, commercial ) {
        api.post(
            {   action:'set_commercial',
                sessionId:this.props.type+devisId,
                commercial:commercial
            },
            (res)=>{}
        )
    }

    setStatusProcess( devisId, status_process ) {
        api.post(
            {   action:'set_status_process',
                sessionId:this.props.type+devisId,
                status_process:status_process
            },
            (res)=>{}
        )
    }

    sendDevisEmail( devisId, onSuccess ) {
        api.post(
            {   action:'send_devis_email',
                sessionId:this.props.type+devisId
            }, onSuccess
        )
    }

    setComment( devisId, comment ) {
        api.post(
            {   action:'add_comment',
                sessionId:this.props.type+devisId,
                comment:comment
            },
            (res)=>{}
        )
    }

    
    pickStatus( devisId, status ) {
        api.post(
            {   action:'set_status',
                sessionId:this.props.type+devisId,
                status:status
            },
            (res)=>{
                this.setState({
                    unfoldedMarker:false
                })
            }
        )
    }

    unfoldMarker(id) {
        this.setState({unfoldedMarker:id})
    }

    updateDevisField(id,field,value) {
        let list = this.state.devis
        list = list.map(
            devis => {
                if ( devis._id.$oid == id ) {
                    devis[field] = value
                }
                return devis
            }
        )
        this.setState({devis:list})
    }

    render() {

        const {operator} = this.props
        const isMoto = this.props.type == 'moto'
        const topLevel = ! this.props.email

        const list = this.state.devis.map(
            devis=> <Devis 
                operator={operator}
                key={devis._id.$oid} 
                container={this}
                topLevel={topLevel}
                devis={new DataDevis(devis)} 
                quotations={this.props.quotations}
                users={this.state.users}
                getSponsor={this.getSponsor.bind(this)}
                unfoldedMarker={devis._id.$oid==this.state.unfoldedMarker}
                updateDevisField={this.updateDevisField.bind(this)}
                />
        )

        const statusDisplay = topLevel && <StatusDisplay/>
        const searchBar = topLevel && <SearchBar
            exportCsv={this.exportCsv.bind(this)}
            loadCount={this.loadCount.bind(this)}
            type={this.props.type}
            operator={this.props.operator}
            app={this.props.container}
            quotations={this.props.quotations}
            startDate={this.props.startDate ? this.props.startDate : ''} 
            endDate={this.props.endDate ? this.props.endDate : ''} 
            startDateModif={this.props.startDateModif ? this.props.startDateModif : ''} 
            endDateModif={this.props.endDateModif ? this.props.endDateModif : ''} 
            dateType={ this.props.dateType ? this.props.dateType : 'creation' }
            searchStatusProcess={this.props.searchStatusProcess}
            searchStatus={this.props.searchStatus}
            searchSelf={this.props.searchSelf}
            searchUser={this.props.searchUser}
            searchApporteur={this.props.searchApporteur}
            searchNoSolly={this.props.searchNoSolly}
            searchAffiliateOnly={this.props.searchAffiliateOnly}
            searchAssureur={this.props.searchAssureur}
            searchAssureurOrigin={this.props.searchAssureurOrigin}
            count={this.state.count}
            loading={this.state.loading}
            loadingCount={this.state.loadingCount}
        />

        const titleBar = ( topLevel && list.length ) ? ( 
            this.props.quotations ? 
            <tr>
                <th></th>
                {isMoto?<>
                    <th>M1</th>
                    <th>M2</th>
                    <th>M3</th>
                    <th>M7</th>
                </>:<>
                    <th>L1</th>
                    <th>L2</th>
                    <th>L3</th>
                </>}
                <th>Véhicule</th>
                <th>Modèle comparateurs</th>
                <th>Apporteur</th>
                <th>Effet</th>
                <th>Création</th>
            </tr> :
            <tr>
            <th></th>
            {operator?<th>Commercial</th>:<></>}
            <th></th>
            <th>NOM Prénom</th>
            <th>email</th>
            <th>Téléphone</th>
            <th>Coût total / Acompte / Mensuel</th>
            {(operator&&isMoto)?<><th>Solly</th>{/*<th>Maxance</th>*/}<th>AXA</th><th>FMA</th></>:<></>}
            {operator?<th>Références assureur</th>:<></>}
            <th>Véhicule</th>
            {(operator&&isMoto)?<th>Modèle comparateurs</th>:<></>}
            <th>Status</th>
            <th>Apporteur</th>
            {operator?<th>Numéro de commande / Transaction</th>:<></>}
            {operator?<th>MER</th>:<></>}
            <th>Effet</th>
            <th>Dernière modification</th>
            <th>Création</th>
            <th>Avancement</th>
        </tr> ) : ''


        return <React.Fragment>
            {searchBar}
            {statusDisplay}
            <CreateNewDevis type={this.props.type} operator={operator} />
            {list.length ? 
                <table onClick={this.unfoldMarker.bind(this,false)}>
                    <tbody>
                        {titleBar}
                        {list}
                        {/*<tr ref={this.bottomRef}>
                            <td colSpan="7">...</td>
                        </tr>*/}
                    </tbody>
                </table> : <div className="empty_list">Aucun devis pour l'instant</div>}
            <div ref={this.bottomRef}>...</div>
            <img className='bottomButton' src='img/arrow-circle.png' onClick={this.backToTop.bind(this)}/>
        </React.Fragment>
    }
}

export default ListDevis;
